import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  id: "billUserModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Edit Tagihan Siswa"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row g-3" }
const _hoisted_7 = { class: "col-md-12 mb-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Nama Tagihan", -1)
const _hoisted_9 = { class: "col-md-12 mb-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Bulan Pembayaran", -1)
const _hoisted_11 = {
  class: "form-select",
  "aria-label": "Default select example",
  disabled: ""
}
const _hoisted_12 = { selected: "" }
const _hoisted_13 = { class: "col-md-12 mb-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Detail Biaya", -1)
const _hoisted_15 = { class: "table table-borderless" }
const _hoisted_16 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th"),
    /*#__PURE__*/_createVNode("th", null, "Nama"),
    /*#__PURE__*/_createVNode("th", null, "Biaya")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("ion-icon", { name: "trash-outline" }, null, -1)
const _hoisted_18 = { class: "col-md-12 mb-3" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Total Biaya", -1)
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Akumulasi Denda", -1)
const _hoisted_22 = { class: "col-md-12 mb-3" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Pengaturan Denda", -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = /*#__PURE__*/_createVNode("option", { value: "percentage" }, "Persentase", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("option", { value: "nominal" }, "Nominal", -1)
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "input-group mb-3" }
const _hoisted_30 = {
  key: 0,
  class: "input-group-text"
}
const _hoisted_31 = {
  key: 1,
  class: "input-group-text"
}
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = /*#__PURE__*/_createVNode("option", { value: "flat" }, "Flat", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("option", { value: "rollover" }, "RollOver", -1)
const _hoisted_35 = { class: "col-md-12 mb-3" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Keterangan", -1)
const _hoisted_37 = { class: "col-md-6 mb-3" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Tanggal Pengingat", -1)
const _hoisted_39 = { class: "col-md-6 mb-3" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Tanggal Batas", -1)
const _hoisted_41 = { class: "col-md-12" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Catatan", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("ion-icon", { name: "save-outline" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Simpan Catatan ")
const _hoisted_45 = { class: "col-md-12 mb-3" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Publikasi", -1)
const _hoisted_47 = { class: "form-check form-switch" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { class: "form-check-label" }, "Terpublish", -1)
const _hoisted_49 = { class: "col-md-12 mb-3" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" pada ")
const _hoisted_51 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" pada ")
const _hoisted_54 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_55 = { class: "col-md-12 mb-3" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Terakhir diubah oleh ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" pada ")
const _hoisted_58 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_59 = { class: "modal-footer" }
const _hoisted_60 = /*#__PURE__*/_createVNode("ion-icon", { name: "trash" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Hapus Tagihan ")
const _hoisted_62 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }),
  /*#__PURE__*/_createTextVNode(" Tutup")
], -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("ion-icon", { name: "save-outline" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Simpan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrencyInputDisable = _resolveComponent("CurrencyInputDisable")
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")
  const _component_datepicker = _resolveComponent("datepicker")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("form", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.data.bill_name = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.data.bill_name]
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("select", _hoisted_11, [
                _createVNode("option", _hoisted_12, _toDisplayString(_ctx.data.bill_month), 1)
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("table", _hoisted_15, [
                _hoisted_16,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.details, (detail, i) => {
                    return (_openBlock(), _createBlock("tr", { key: i }, [
                      _createVNode("td", null, [
                        (detail.id == '')
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn text-secondary btn-icon",
                              onClick: ($event: any) => (_ctx.removeDetail(i))
                            }, [
                              _hoisted_17
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _withDirectives(_createVNode("input", {
                        type: "hidden",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (detail.id = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, detail.id]
                      ]),
                      _createVNode("td", null, [
                        _withDirectives(_createVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": ($event: any) => (detail.bill_detail.operation = $event),
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.calculatePrice())),
                          disabled: ""
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.math_operations, (operation) => {
                            return (_openBlock(), _createBlock("option", {
                              key: operation.id,
                              label: operation.id,
                              value: operation.symbol
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ], 40, ["onUpdate:modelValue"]), [
                          [_vModelSelect, detail.bill_detail.operation]
                        ])
                      ]),
                      _createVNode("td", null, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => (detail.bill_detail.name = $event),
                          readonly: ""
                        }, null, 8, ["onUpdate:modelValue"]), [
                          [_vModelText, detail.bill_detail.name]
                        ])
                      ]),
                      _createVNode("td", null, [
                        (_ctx.data.state == 'detail')
                          ? (_openBlock(), _createBlock(_component_CurrencyInputDisable, {
                              key: 0,
                              modelValue: detail.amount,
                              "onUpdate:modelValue": ($event: any) => (detail.amount = $event),
                              options: _ctx.config,
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.calculatePrice()))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                          : (_openBlock(), _createBlock(_component_CurrencyInput, {
                              key: 1,
                              modelValue: detail.amount,
                              "onUpdate:modelValue": ($event: any) => (detail.amount = $event),
                              options: _ctx.config,
                              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.calculatePrice()))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_CurrencyInputDisable, {
                modelValue: _ctx.data.total_amount,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.data.total_amount = $event)),
                options: _ctx.config
              }, null, 8, ["modelValue", "options"])
            ]),
            _createVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_CurrencyInputDisable, {
                modelValue: _ctx.data.late_charge,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.data.late_charge = $event)),
                options: _ctx.config
              }, null, 8, ["modelValue", "options"])
            ]),
            _createVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.data.fine_rules.type = $event)),
                    disabled: ""
                  }, [
                    _hoisted_26,
                    _hoisted_27
                  ], 512), [
                    [_vModelSelect, _ctx.data.fine_rules.type]
                  ])
                ]),
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    (_ctx.data.fine_rules.type == 'nominal')
                      ? (_openBlock(), _createBlock("span", _hoisted_30, "Rp"))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode("input", {
                      type: "number",
                      class: "form-control text-success text-end",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.data.fine_rules.value = $event)),
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, _ctx.data.fine_rules.value]
                    ]),
                    (_ctx.data.fine_rules.type == 'percentage')
                      ? (_openBlock(), _createBlock("span", _hoisted_31, "%"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_32, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.data.fine_rules.formula = $event)),
                    disabled: ""
                  }, [
                    _hoisted_33,
                    _hoisted_34
                  ], 512), [
                    [_vModelSelect, _ctx.data.fine_rules.formula]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_35, [
              _hoisted_36,
              _withDirectives(_createVNode("textarea", {
                class: "form-control text-secondary",
                rows: "2",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.data.description = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.data.description]
              ])
            ]),
            _createVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode(_component_datepicker, {
                class: "form-control",
                modelValue: _ctx.data.due_date,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.data.due_date = $event)),
                readonly: _ctx.data.state == 'detail'
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode(_component_datepicker, {
                class: "form-control",
                modelValue: _ctx.data.deadline_date,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.data.deadline_date = $event)),
                readonly: _ctx.data.state == 'detail'
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createVNode("div", _hoisted_41, [
              _hoisted_42,
              _withDirectives(_createVNode("textarea", {
                class: "form-control text-secondary",
                rows: "2",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.data.note = $event))
              }, null, 512), [
                [_vModelText, _ctx.data.note]
              ]),
              (_ctx.data.state == 'detail')
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-warning float-end mt-1",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveNote()))
                  }, [
                    _hoisted_43,
                    _hoisted_44
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_45, [
              _hoisted_46,
              _createVNode("div", _hoisted_47, [
                _withDirectives(_createVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.data.is_published = $event)),
                  disabled: _ctx.data.state == 'detail'
                }, null, 8, ["disabled"]), [
                  [_vModelCheckbox, _ctx.data.is_published]
                ]),
                _hoisted_48
              ])
            ]),
            _createVNode("div", _hoisted_49, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.log1, (log, i) => {
                return (_openBlock(), _createBlock("div", { key: i }, [
                  _createVNode("small", null, [
                    _createTextVNode("Di" + _toDisplayString(_ctx.constants(log.operation)) + " oleh ", 1),
                    _createVNode("b", null, _toDisplayString(log.user_name), 1),
                    _hoisted_50,
                    _createVNode("b", null, _toDisplayString(_ctx.beautifyDatetime(log.timestamp)), 1)
                  ]),
                  _hoisted_51
                ]))
              }), 128)),
              (_ctx.readMoreActivated)
                ? (_openBlock(), _createBlock("div", _hoisted_52, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.log2, (log, i) => {
                      return (_openBlock(), _createBlock("div", { key: i }, [
                        _createVNode("small", null, [
                          _createTextVNode("Di" + _toDisplayString(_ctx.constants(log.operation)) + " oleh ", 1),
                          _createVNode("b", null, _toDisplayString(log.user_name), 1),
                          _hoisted_53,
                          _createVNode("b", null, _toDisplayString(_ctx.beautifyDatetime(log.timestamp)), 1)
                        ]),
                        _hoisted_54
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.log2.length > 0)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.readMoreActivated = !_ctx.readMoreActivated && _ctx.readMoreActivated == false))
                  }, [
                    _createVNode("small", null, "Tampilkan lebih " + _toDisplayString(_ctx.readMoreActivated ? 'sedikit' : 'banyak') + "...", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_55, [
              _createVNode("small", null, [
                _hoisted_56,
                _createVNode("b", null, _toDisplayString(_ctx.data.user_updated ? _ctx.data.user_updated.name : ''), 1),
                _hoisted_57,
                _createVNode("b", null, _toDisplayString(_ctx.data.updated_at), 1)
              ]),
              _hoisted_58
            ])
          ])
        ]),
        _createVNode("div", _hoisted_59, [
          ((_ctx.data.is_published == false && (_ctx.data.status == _ctx.constantscode.BILL_PENDING || _ctx.data.status == _ctx.constantscode.BILL_UNPAID)))
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-danger me-auto",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.deleteBill()))
              }, [
                _hoisted_60,
                _hoisted_61
              ]))
            : _createCommentVNode("", true),
          _hoisted_62,
          _createVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.save())),
            disabled: _ctx.data.state == 'detail'
          }, [
            _hoisted_63,
            _hoisted_64
          ], 8, ["disabled"])
        ])
      ])
    ])
  ]))
}